var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 15C13.6564 15 14.9995 13.6569 14.9995 12C14.9995 10.3431 13.6564 9 11.9995 9C10.3427 9 8.99951 10.3431 8.99951 12C8.99951 13.6569 10.3427 15 11.9995 15Z",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9995 46C27.6564 46 28.9995 44.6569 28.9995 43C28.9995 41.3431 27.6564 40 25.9995 40C24.3427 40 22.9995 41.3431 22.9995 43C22.9995 44.6569 24.3427 46 25.9995 46Z",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 14C41.6564 14 42.9995 12.6569 42.9995 11C42.9995 9.34315 41.6564 8 39.9995 8C38.3427 8 36.9995 9.34315 36.9995 11C36.9995 12.6569 38.3427 14 39.9995 14Z",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9995 45.9395C43.6564 45.9395 44.9995 44.5963 44.9995 42.9395C44.9995 41.2826 43.6564 39.9395 41.9995 39.9395C40.3427 39.9395 38.9995 41.2826 38.9995 42.9395C38.9995 44.5963 40.3427 45.9395 41.9995 45.9395Z",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9994 34.9994H28.9994L25.9994 31.9994V28.9994H22.9994L15.3994 21.3994C13.2535 22.1798 10.9056 22.2048 8.74355 21.4704C6.58149 20.736 4.73462 19.286 3.50802 17.3601C2.28143 15.4341 1.74848 13.1474 1.99722 10.8776C2.24597 8.60777 3.26151 6.49071 4.87611 4.87611C6.49071 3.26151 8.60777 2.24597 10.8776 1.99722C13.1474 1.74848 15.4341 2.28143 17.3601 3.50802C19.286 4.73462 20.736 6.58149 21.4704 8.74355C22.2048 10.9056 22.1798 13.2535 21.3994 15.3994L23.9994 17.9994H32.9994L37.8784 13.1204",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9233 22.9238L31.9993 25.9998V28.9998H34.9993L41.9993 34.9998V39.9998V38.9998",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9995 25V36L23.8785 40.879",
    stroke: "#F2994A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon_reset.e83650b3.svg";
export { ForwardRef as ReactComponent };